var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpwardOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 20V4C13 3.45614 12.5439 3 12 3C11.4561 3 11 3.45614 11 4V20C11 20.5439 11.4561 21 12 21C12.5439 21 13 20.5439 13 20ZM11.2982 4.70175L18.2982 11.7018C18.4737 11.8947 18.7193 12 19 12C19.5439 12 20 11.5439 20 11C20 10.7193 19.8947 10.4737 19.7018 10.2982L12.7018 3.29825C12.5263 3.10526 12.2807 3 12 3C11.4561 3 11 3.45614 11 4C11 4.2807 11.1053 4.52632 11.2982 4.70175ZM5.70175 11.7018L12.7018 4.70175C12.8947 4.52632 13 4.2807 13 4C13 3.45614 12.5439 3 12 3C11.7193 3 11.4737 3.10526 11.2982 3.29825L4.29825 10.2982C4.10526 10.4737 4 10.7193 4 11C4 11.5439 4.45614 12 5 12C5.2807 12 5.52632 11.8947 5.70175 11.7018Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpwardOutlined);
export default __webpack_public_path__ + "static/media/arrow_upward_outlined.f13bd2f9.svg";
export { ForwardRef as ReactComponent };